import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import get from 'lodash/get';
import { PapiDeviation, PapiEditorText } from '@wix/da-papi-types';
import DeviationDumbView from '../../../Dumbo/EditorDumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import ExcerptRenderer from '../../../../TextRenderer/ExcerptRenderer';
import { getFirstExample } from '../../../Dumbo/Commission/Commission';
import { ResourceType } from '../../../../types/resource';

import shopThumbStyles from '../../Shop/ShopThumb.scss';

export interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
  disabled?: boolean;
  disabledLabel?: string;
  textContent?: PapiEditorText;
  addLink?: boolean;
  showTitle?: boolean;
}

const Content: React.FC<Props & WithTranslation> = ({
  width,
  height,
  disabled,
  deviation,
  textContent,
  disabledLabel,
  addLink = true,
  t,
  showTitle,
}) => {
  const example = get(deviation, 'coverImage') || getFirstExample(deviation);

  const renderContent = () => (
    <>
      <DeviationDumbView deviation={deviation} width={width} height={height} />
      <div className={shopThumbStyles['thumb-overlay']} />
      <div className={shopThumbStyles['thumb-overlay-top']} />
      {disabled && disabledLabel && (
        <div className={shopThumbStyles['thumb-disabled-overlay']}>
          <div>{t!(disabledLabel!)}</div>
        </div>
      )}
      {showTitle && (
        <div className={shopThumbStyles['thumb-title-overlay']}>
          {deviation.title}
        </div>
      )}
      <div className={shopThumbStyles['description']}>
        <ExcerptRenderer textContent={textContent} />
      </div>
    </>
  );

  if (!addLink) {
    return renderContent();
  }

  return (
    <DeviationLink
      deviation={deviation}
      data-itemid={example?.deviationId}
      data-typeid={ResourceType.DEVIATION}
      className={shopThumbStyles['thumb']}
    >
      {renderContent()}
    </DeviationLink>
  );
};

export default withTranslation()(Content) as React.ComponentType<Props>;
